export const CANCELED = 'canceled';
export const REJECTED = 'rejected';
export const APPROVED = 'approved';
export const PENDING = 'pending';

export enum ReceiverColumns {
  STATUS = 'status',
  COMPANY = 'name',
}
